module.exports = __webpack_public_path__ + "img/Modern-Heritage.a5b8862d.jpg";